export default {
  apiKey: "AIzaSyD8NV5n20AMriL9_VJNlxinwtWqypr4kAY",
  authDomain: "iprog-project-d06b3.firebaseapp.com",
  databaseURL:
    "https://iprog-project-d06b3-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "iprog-project-d06b3",
  storageBucket: "iprog-project-d06b3.appspot.com",
  messagingSenderId: "395877729500",
  appId: "1:395877729500:web:ed5bb1da8d26554735a019",
};
